import React, { useState } from "react";
import _ from "lodash";
import clsx from "clsx";

import { CircularProgress } from "@material-ui/core";

import { useGlobalSearchContext } from "../../context/globalSearch.context";
import { ResultGroup } from "./components/ResultGroup/ResultGroup";
import { SearchField } from "./components/SearchField/SearchField";
import { NotFound } from "../NotFound/NotFound";
import { ERequestState } from "../../types/RequestState";

export function SearchPanel() {
	const { handleToggleOpen, request, groups, isArabic } = useGlobalSearchContext();

	const [expandBackground, setExpandBackground] = useState(false);

	function toggleExpandBg() {
		setExpandBackground(!expandBackground);
	}


	const getContentByRequestState = {
		[ERequestState.Init]: () => <></>,
		[ERequestState.IsLoading]: () => (
			<CircularProgress
				style={{ margin: "40px auto 0px auto", color: "#201F57" }}
			/>
		),
		[ERequestState.EmptyResponse]: () => <NotFound />,
		[ERequestState.WithResult]: () =>
			_.map(groups, (group) => <ResultGroup key={group.title} group={group} />),
	};

	return (
		<div className="GlobalSearch">
			<div
				className="fadeTransition-4"
				style={{ zIndex: 2000, position: "fixed", inset: 0 }}
			>
				<div
					className={clsx({ "paper-5": true, icreaseHeight: expandBackground })}
					style={{
						overflowY:
							groups.length ||
							(request === ERequestState.EmptyResponse)
								? "auto"
								: "hidden",
					}}
					id="modal-paper"
				>
					<button
						onClick={handleToggleOpen}
						className=" close-modal MuiButtonBase-root MuiIconButton-root closeSearchButton-6 MuiIconButton-colorInherit MuiIconButton-edgeStart"
						tabIndex="0"
						type="button"
						aria-label="open drawer"
					>
						<span className="MuiIconButton-label ">
							<svg
								width="21"
								height="19"
								viewBox="0 0 21 19"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M18.9871 17.2698C14.1435 12.6849 4.5207 6.43581 1.69186 0.942752"
									stroke="#363568"
									strokeWidth="3"
								/>
								<path
									d="M18.9719 1.56901C14.1325 6.15844 4.51823 12.4137 1.69189 17.9122"
									stroke="#363568"
									strokeWidth="3"
								/>
							</svg>
							{/* <img alt="close modal" src="./assets/modalClose.svg" /> */}
						</span>
					</button>

					<div className="MuiGrid-root MuiGrid-container MuiGrid-direction-xs-column">
						{/* <!-- Backdrop --> */}
						<div className="backdrop" onClick={handleToggleOpen}></div>

						<div className="MuiGrid-root MuiGrid-container MuiGrid-item">
							<div className="MuiGrid-root MuiGrid-item">
								<span className="MuiTypography-root title-7 MuiTypography-h2">
								{isArabic ? 'بحث' : 'Search'}
								</span>
							</div>
						</div>
						<SearchField toggleExpandBg={toggleExpandBg} />

						{/*  */}

						<div className="MuiGrid-root resultsContainer-22 MuiGrid-container MuiGrid-item">

							{request && getContentByRequestState[request]()}

						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
